define([
	"dojo/_base/declare"
], function(declare) {

	function throwError() {
		throw new Error("Not implemented");
	}

	var SeriesData = declare(null, {
		getName: function() {
			// summary: return a name for the series
			throwError();
		},

		getData: function() {
			// summary: return an array of objects in the format:
			// {
			//	value: <value>,
			//  displayvalue: <optional display value>
			// }
			throwError();
		}
	});

	var GraphData = declare(null, {
		getName: function() {
			// summary: return a name for the graph
			throwError();
		},

		getXAxisName: function() {
			// summary: return a name of X axis data
			throwError();
		},

		getYAxisName: function() {
			// summary: return a name of Y axis data
			throwError();
		},

		getXLabels: function() {
			// summary: return an array of labels for X axis
			throwError();
		},

		getSeries: function() {
			// summary: return an array of SeriesData
			throwError();
		}
	});

	var SlicerDataAccess = declare(null, {
		getGraphs: function(/*String*/metricKey) {
			// summary: return an array of GraphData for the given 'metricKey'
			throwError();
		}
	});

	SlicerDataAccess.GraphData = GraphData;
	SlicerDataAccess.SeriesData = SeriesData;

	return SlicerDataAccess;
});